import React from 'react';
import './PlayerList.css';

/**
 * Generate a unique color gradient for each player based on index
 */
const getPlayerAvatarStyle = (index, isWinner, isCurrent) => {
  // Beautiful gradient color combinations
  const gradients = [
    { from: '#e94560', to: '#c73e54', name: 'red' }, // Original accent
    { from: '#2563eb', to: '#1e40af', name: 'blue' },
    { from: '#16a34a', to: '#15803d', name: 'green' },
    { from: '#facc15', to: '#eab308', name: 'yellow' },
    { from: '#a855f7', to: '#9333ea', name: 'purple' },
    { from: '#f97316', to: '#ea580c', name: 'orange' },
    { from: '#06b6d4', to: '#0891b2', name: 'cyan' },
    { from: '#ec4899', to: '#db2777', name: 'pink' },
  ];

  const gradient = gradients[index % gradients.length];
  
  // Winner gets gold gradient
  if (isWinner) {
    return {
      background: 'linear-gradient(135deg, #ffd700 0%, #ffa500 100%)',
      boxShadow: '0 4px 20px rgba(255, 215, 0, 0.4)',
    };
  }

  // Current player gets enhanced glow
  if (isCurrent) {
    return {
      background: `linear-gradient(135deg, ${gradient.from} 0%, ${gradient.to} 100%)`,
      boxShadow: `0 4px 20px ${gradient.from}40, 0 0 30px ${gradient.from}20`,
      border: `2px solid ${gradient.from}`,
    };
  }

  return {
    background: `linear-gradient(135deg, ${gradient.from} 0%, ${gradient.to} 100%)`,
    boxShadow: `0 4px 15px ${gradient.from}30`,
  };
};

/**
 * Display list of all players in the game
 */
const PlayerList = ({ players, currentPlayerId, currentPlayerIndex, gameType }) => {
  if (!players || players.length === 0) {
    return null;
  }

  const isUno = gameType === 'uno';
  const isKittens = gameType === 'explodingKittens';
  const isTurnBased = isUno || isKittens;

  return (
    <div className="player-list">
      <h3 className="player-list-title">Players</h3>
      <div className="players-grid">
        {players.map((player, index) => {
          const isCurrentTurn = isTurnBased && currentPlayerIndex !== undefined && index === currentPlayerIndex;
          const isCurrent = player.id === currentPlayerId;
          const avatarStyle = getPlayerAvatarStyle(index, player.isWinner, isCurrent);
          
          return (
            <div 
              key={player.id} 
              className={`player-item ${isCurrent ? 'current' : ''} ${player.isWinner ? 'winner' : ''} ${isCurrentTurn ? 'active-turn' : ''}`}
            >
              <div 
                className="player-avatar"
                style={avatarStyle}
              >
                {player.isWinner ? '👑' : player.name.charAt(0).toUpperCase()}
              </div>
              <div className="player-info">
                <span className="player-name">
                  {player.name}
                  {player.isHost && <span className="host-badge">HOST</span>}
                  {player.id === currentPlayerId && <span className="you-badge">YOU</span>}
                  {isCurrentTurn && <span className="turn-badge">TURN</span>}
                  {isUno && player.cards?.length === 1 && player.hasCalledUno && (
                    <span className="uno-badge">UNO!</span>
                  )}
                </span>
              <span className="player-cards">
                {player.cards?.length || 0} cards
                {gameType === 'explodingKittens' && player.isAlive === false && (
                  <span style={{ color: '#dc2626', marginLeft: '8px' }}>💀 Dead</span>
                )}
              </span>
              </div>
              {player.isWinner && (
                <span className="winner-badge">🏆 WINNER!</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlayerList;


